import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { AdminService } from 'src/app/workflow/admin/admin.service';
import { GipAdmDocPubForm, GipAdmDocPubModel } from 'src/app/workflow/admin/gipAdmContentList/gipAdmContentList.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationWindow } from 'src/app/template/deleteTemplate/confirmationWindow.component';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

@Component({
  selector: 'app-gip-adm-docpub',
  templateUrl: './gipAdmDocpub.component.html',
  styleUrls: ['./gipAdmDocpub.component.css']
})
export class GipAdmDocPubComponent implements OnInit, OnDestroy {

  @Output() public submit = new EventEmitter();

  constructor(
    private shareData: SharingDataService,
    private adminService: AdminService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    private errorHandlingService: ErrorHandlingService
  ) { }

  ngOnDestroy(): void {
    this.modelInput.controls.VALIDFROM.setValidators(null);
    this.modelInput.controls.VALIDTO.setValidators(null);
  }

  isEdit: boolean;
  isNewForm;
  id: string;
  currentLanguage: string = 'en';
  resourceDefinition;
  urlBase: string = 'admin/MS_PROFIL_ENVELOP_DOCU';
  fileToUpload: File;


  modelInput = GipAdmDocPubForm;


  formular = [
    { formControlName: "CATEGORY", hidden: false, required: true, readonly: true, editReadonly: true, newReadonly: true, newRow: true },
    { formControlName: "OBJECTID", hidden: false, required: true, readonly: false, editReadonly: false, newReadonly: false, picklist: "V_GIP_DOCTYPE_VL_T"  },
    { formControlName: "VALIDFROM", hidden: false, required: true, datepicker: true, datepickerType: "validFrom", readonly: false, editReadonly: false, newReadonly: false, newRow: true, datepickerMax : null, datepickerMin : null },
    { formControlName: "VALIDTO", hidden: false, required: true, datepicker: true, datepickerType: "validTo", readonly: false, editReadonly: false, newReadonly: false, datepickerMax : null, datepickerMin : null },
    { formControlName: "CONTENTTYPE", hidden: false, readonly: true, editReadonly: true, newReadonly: true, newRow: true  },
    { formControlName: "USERNAME", hidden: false, readonly: true, editReadonly: true, newReadonly: true  },
    { formControlName: "PATH", hidden: false, readonly: true, editReadonly: true, newReadonly: true  },
    { formControlName: "REMARK", hidden: false, textArea: true, readonly: false, editReadonly: false, newReadonly: false, newRow: true  },
    { formControlName: "HINT", hidden: false, readonly: true, textArea: true, editReadonly: true, newReadonly: true, newRow: true  },
    { formControlName: "btn_chooseFile", hidden: false, upload: true},
    { formControlName: "btn_upload", button: true, type: "submit", function: "uploadBtnAction" },
    { formControlName: "btn_save", button: true, function: "btnSaveAction", type:"submit",},
    { formControlName: "btn_delete", hidden: true, button: true, function: "deleteBtnAction", type:"button",},
    { formControlName: "btn_back", button: true, function: "btnBackAction", type:"button", newRow: true},

  ];


  ngOnInit(): void {
    this.shareData.currentLanguage.subscribe(data => this.currentLanguage = data);
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);

    this.getUrlParams();
    if (this.id != undefined) {
      this.getDataEdit();
    }
    else {
      this.changeToNew();
    }
  }

  action(action) {
    this[action]();
  }

  onSubmit() {
    this.submit.emit();
  }

  getUrlParams(){
    this.route.queryParams
    .subscribe(params => {
      if(params.id != undefined){
        this.id = params.id;
        this.setReadonly();
      } else this.changeToNew();

      if(params.isEdit != undefined){
        this.isEdit = params.isEdit;
        this.setReadonly();
      }
    });
  }

  setReadonly() {
    if (!this.isEdit && this.isEdit == undefined) {
      this.changeToDisplay();
    } else if (this.isEdit) {
      this.changeToEdit();
    }
  }


  changeToEdit() {
    this.formular.forEach(element => {
      if (element.editReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
      if(element.formControlName == "btn_upload") element.hidden = true;
      if(element.formControlName == "btn_delete") element.hidden = false;
      if(element.formControlName == "btn_chooseFile") element.hidden = true;
      if(element.formControlName == "btn_save") element.hidden = false;
    });
  }

  changeToDisplay() {
    this.formular.forEach(element => {
      element.readonly = true;
    });
  }

  changeToNew() {
    this.getDataNew();
    this.isNewForm = true;
    this.modelInput.reset();
    this.formular.forEach(element => {
      if (element.newReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
      if(element.formControlName == "CONTENTTYPE" || element.formControlName == "USERNAME" || element.formControlName == "PATH"){
        element.hidden = true;
      }
      if(element.formControlName == "HINT"){
        element.newRow = true;
      }
      if(element.formControlName == "VALIDFROM") element.datepickerMin = new Date();
      if(element.formControlName == "VALIDTO") element.datepickerMin = new Date();
      if(element.formControlName == "btn_delete") element.hidden = true;
      if(element.formControlName == "btn_save") element.hidden = true;
      if(element.formControlName == "btn_chooseFile") element.hidden = false;
      if(element.formControlName == "btn_upload") element.hidden = false;
    });
    this.modelInput.controls.CATEGORY.setValue("PUB")
  }

  getDataEdit() {
    this.modelInput.reset();
    let urls = [
      `${this.urlBase}?$filter=ID eq ${this.id}`,
      `Admin/V_GIP_TEXT_T?$filter=TEXTID eq 'ADM_UL_MSG' and LANG eq '${this.currentLanguage}'`
    ];
    var data = this.adminService.getData(urls, (data) => {
      if(data[0][0] != undefined){
        for (var dataElement in data[0][0]){
          for (var value in this.modelInput.value) {
            if (dataElement == value) {
              this.modelInput.controls[value].setValue(data[0][0][dataElement])
            }
          }
        }
        if(data[1][0] != undefined){
          for (var dataElement in data[1][0]){
            for (var value in this.modelInput.value) {
              if (dataElement == "TEXT") {
                this.modelInput.controls.HINT.setValue(data[1][0][dataElement])
              }
            }
          }
        }
      }
      this.setDateMaxMin();
    });
  }

  getDataNew() {
    let urls = [
      `Admin/V_GIP_TEXT_T?$filter=TEXTID eq 'ADM_UL_MSG' and LANG eq '${this.currentLanguage}'`
    ];
    var data = this.adminService.getData(urls, (data) => {
      if (data[0][0] != undefined) {
        for (var dataElement in data[0][0]) {
          for (var statisticElement in this.modelInput.value) {
            if (dataElement == statisticElement && dataElement == "TEXT") {
              this.modelInput.controls.HINT.setValue(data[0][0][dataElement])
            }
          }
        }
      }
    });
  }

  setFileToUpload(file){
    console.log(file)
    this.fileToUpload = file;
  }

  btnSaveAction() {
      this.updateData();
    
  }

  btnBackAction(){
    this.router.navigate([`/gipAdmDocpubList`]);
  }

  dateChange(date) {
    if (date.type == "validFrom") {
      this.modelInput.controls.VALIDFROM.setValue(date.value);
    } else if (date.type == "validTo") {
      this.modelInput.controls.VALIDTO.setValue(date.value);
    }
    this.setDateMaxMin();
  }

  setDateMaxMin() {
    this.formular.forEach(element => {
      if (element.formControlName == "VALIDFROM" && this.modelInput.value.VALIDTO != null) {
        element.datepickerMax = this.modelInput.value.VALIDTO;
      }
      if (element.formControlName == "VALIDTO" && this.modelInput.value.VALIDFROM != null) {
        element.datepickerMin = this.modelInput.value.VALIDFROM;
      }
    });
  }

  uploadBtnAction(){
    this.postData();
  }

  postData(){
    console.log(this.modelInput)
    if(this.modelInput.status == "VALID"){
      let model = new GipAdmDocPubModel();
      model.fromFormGroupModel(this.modelInput);
      let response: any;

      var object = {
        files: this.fileToUpload,
        MS_PROFIL_ENVELOP_DOCU : model,
      }

      this.adminService.postAccesoryDocuments("file/PublicFile", object, (data) => {
        this.btnBackAction();
      }, this.handlePostError);
    }
  }

  handlePostError(response: any){
    var error = '';

    if (response.status == 431){
      error = this.translateResourceDefinition.transform("FileTooLarge", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common")
      this.errorHandlingService.showError(error);
    } else if(response.status == 415){
      error = this.translateResourceDefinition.transform("UnsupportedMediaType", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common")
      this.errorHandlingService.showError(error);
    }
    else {
      error = this.adminService.getDefaultErrorMessage();
      this.errorHandlingService.showError(error);
    }
  }

  saveBtnAction() {
    this.updateData();
  }

  updateData() {
    if(this.modelInput.status == "VALID"){
      let model = new GipAdmDocPubModel();
      model.fromFormGroupModel(this.modelInput);

      this.adminService.updateData("admin/MS_PROFIL_ENVELOP_DOCU", model, model.getUpdateMap(), (data) => {
        this.btnBackAction();
      });
    }
  }

  deleteBtnAction() {
    const dialogRef = this.dialog.open(ConfirmationWindow, {
      data: {
        Title : "ConfirmDeleteTitle",
        Text : "ConfirmDeleteText",
        Placeholders: [this.modelInput.value.USERNAME],
        Actions: [{
          Text: "ConfirmYes",
          Function: "REMOVE",
        },
        {
          Text: "ConfirmNo",
        }]
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "REMOVE") {
        let model = new GipAdmDocPubModel();
        model.fromFormGroupModel(this.modelInput);
        this.adminService.deleteDataOld("file/PublicFileDelete", [model.ID], (data) => {
          this.btnBackAction();
        });
      }
    });
  }
}
